import configLoader from './../../helpers/configs/ConfigLoader';

class ApiService {
    constructor() {
        this.baseUrl = configLoader.get("API_BASE_URL");
        this.headers = { "Content-Type": "application/json" };
        this.payload = {};
    }

    setHeader(name, value) {
        this.headers[name] = value;
    }

    getHeader(name) {
        return this.headers[name] || null;
    }

    removeHeader(name) {
        delete this.headers[name];
    }

    setPayload(key, value) {
        this.payload[key] = value;
    }

    getPayload() {
        return this.payload;
    }

    clearPayload() {
        this.payload = {};
    }

    async request(method, endpoint) {
        try {
            const options = {
                method,
                headers: this.headers,
                body: JSON.stringify(this.payload),
            };

            const response = await fetch(`${this.baseUrl}${endpoint}`, options);
            if (!response.ok) throw new Error(`Error ${response.status}: ${response.statusText}`);
            return await response.json();
        } catch (error) {
            console.error(`Fetch ${method} Error:`, error);
            throw error;
        }
    }

    get(endpoint) {
        return this.request(configLoader.get("API_METHOD_GET"), endpoint);
    }

    post(endpoint) {
        return this.request(configLoader.get("API_METHOD_POST"), endpoint);
    }

    put(endpoint) {
        return this.request(configLoader.get("API_METHOD_PUT"), endpoint);
    }

    delete(endpoint) {
        return this.request(configLoader.get("API_METHOD_DELETE"), endpoint);
    }
}

const apiService = new ApiService();
export default apiService;